import { Directive, HostBinding, Input } from '@angular/core';

export type IconSize = 'xx-small' | 'x-small' | 'small' | 'medium' | 'large' | 'x-large';

@Directive({
  selector: 'fa-icon[xIconSize]',
})
export class IconSizeDirective {
  @HostBinding('class')
  size: string = 'icon-size-medium';

  @Input() set xIconSize(size: IconSize) {
    this.size = `icon-size-${size}`;
  }

  constructor() {}
}
